var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-alert',{attrs:{"title":_vm.hidePhoneNum,"type":"success","description":"已登录","close-text":"退出登录","show-icon":""},on:{"close":_vm.loginOut}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }